module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery4.dc79f1a6d68901c82f9121de4ee668ab.png";